<template>
	<div>
		<!-- Case Credentials -->
		<case-overview-credentials />

		<!-- Holder -->
		<case-overview-holder class="mt4" />

		<!-- TODO: other holders -->
		<case-overview-other-holders class="mt4" />

		<!-- Insureds -->
		<case-overview-insureds class="mt4" />

		<!-- Case Facts -->
		<case-overview-facts class="mt10" />

		<!-- Payment Info -->
		<case-payment-infos class="mt10" />

		<!-- Beneficiary Info -->
		<case-beneficiaries class="mt10" />
	</div>
</template>

<script>
import CaseOverviewHolder from "./CaseOverviewHolder"
import CaseOverviewOtherHolders from "./CaseOverviewOtherHolders"
import CasePaymentInfos from "./CasePaymentInfos"
import CaseOverviewInsureds from "./CaseOverviewInsureds"
import CaseOverviewFacts from "./CaseOverviewFacts"
import CaseOverviewCredentials from "./CaseOverviewCredentials"
import CaseBeneficiaries from "./CaseBeneficiaries"

export default {
	components: {
		CaseOverviewHolder,
		CaseOverviewOtherHolders,
		CaseBeneficiaries,
		CaseOverviewInsureds,
		CaseOverviewFacts,
		CasePaymentInfos,
		CaseOverviewCredentials
	}
}
</script>
